// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"a1d7b105","212":"7e3641ec","281":"70b03d14","291":"5de34256","533":"113923fd","623":"ddaf6dae","725":"784a103a","838":"cc8ca841","891":"6cbc0bbd"}[chunkId] + ".chunk.js";
};